import React, { FC } from 'react';
import { EmptyStateCard } from '@fdha/web-ui-library';

interface DeliveryEmptyStateProps {
  isCanceled: boolean;
  isClosedDelivery?: boolean;
}

/**
 * Component to display when there are no meal selections in a delivery
 */
const DeliveryEmptyState: FC<DeliveryEmptyStateProps> = ({ isCanceled }) => {
  if (isCanceled) {
    return (
      <EmptyStateCard
        message="No dishes selected for this delivery."
        i18nKeyMessage="meals:reviewDelivery.canceledEmptyState"
      />
    );
  }

  return (
    <EmptyStateCard
      message="You'll receive the default meals set by Food Ops team. It's possible to set a custom menu by editing an open delivery."
      i18nKeyMessage="meals:reviewDelivery.emptyState"
    />
  );
};

export default DeliveryEmptyState;
